import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { service_url } from "./service-url";
@Injectable({
  providedIn: 'root'
})
export class MedicineUnitService {

  api_url: any
  constructor(private http: HttpClient) {
    this.api_url = service_url.api_url
  }

  getMedicineUnits(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/medicine_units', { params: params })
  }

  showMedicineUnit(medicine_unit_id) {
    return this.http.get(this.api_url + '/medicine_units/' + medicine_unit_id)
  }

  submitMedicineUnit(params, id = '') {
    if (id != '') {
      return this.http.put(this.api_url + '/medicine_units/' + id, params)
    }
    else {
      return this.http.post(this.api_url + '/medicine_units', params)
    }
  }

  deleteMedicineUnit(medicine_unit_id) {
    return this.http.delete(this.api_url + '/medicine_units/' + medicine_unit_id)
  }
}
